import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import SubTitle from "../../../components/SubTitle";
import {useGetItemQuery, useUpdateMutation} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";

import {useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import {
  EDCurriculum,
  initializeCurriculum,
} from "../../../models/serverModels/education/EDCurriculum";

import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../../Recoil/Atom/snackBarState";
import * as curriculumListApi from "../../../api/educationApi/curriculumListApi";
import ConfirmButtonGroup from "../../../components/ConfirmButtonGroup";
import MWProgress from "../../../components/MWProgress";
import * as Params from "../../../models/clientModels/interfaces/apiParams";
import {FormSection} from "../../../styledComponents/StyledCreateForm";
import CurriculumForm from "./CurriculumForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {curriculumSchema} from "../../../validation/curriculumSchema";

const UpdateCurriculum = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: curriculum, isLoading: isGetLoading} = useGetItemQuery<ResponseItem<EDCurriculum>>({
    key: ["Curriculum", {token: tokenState, id: parseInt(id!)}],
    api: () => curriculumListApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EDCurriculum>,
    Params.Update<EDCurriculum>
  >({
    api: curriculumListApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/Education/CurriculumList");
        queryClient.invalidateQueries("CurriculumList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<EDCurriculum>({
    defaultValues: curriculum?.item || initializeCurriculum,
    resolver: yupResolver(curriculumSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(curriculum?.item);
  }, [curriculum?.item, reset]);

  const onSubmit: SubmitHandler<EDCurriculum> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeCurriculum, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="교육과정 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <CurriculumForm captionColor="#546E7A" />
            <ConfirmButtonGroup
              link="/Education/CurriculumList"
              cancelText="취소"
              confirmText="저장"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateCurriculum;
